import { render, staticRenderFns } from "./index_see.vue?vue&type=template&id=61971a20&scoped=true"
import script from "./index_see.vue?vue&type=script&lang=js"
export * from "./index_see.vue?vue&type=script&lang=js"
import style0 from "./index_see.vue?vue&type=style&index=0&id=61971a20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61971a20",
  null
  
)

export default component.exports